export default __webpack_public_path__ + "static/media/messagerieLogo.b82c02c3.png";